import type { AppRouteBeforeServerRenderContext } from 'src/shared/routes';

import { getIsCommunityPetition } from 'src/app/shared/api/petitions';

export const handleAdvocatesRedirect = async ({
	params: { slug: slugOrId },
	redirect,
	getSessionUtilities,
}: AppRouteBeforeServerRenderContext): Promise<void> => {
	const sessionUtilities = await getSessionUtilities();

	const isCommunityPetition = await getIsCommunityPetition(slugOrId, sessionUtilities);

	const { environment } = sessionUtilities;

	const isProduction = environment.getEnvironment() === 'production';

	if (!isCommunityPetition && isProduction) {
		redirect(`/p/${slugOrId}`);
	}
};
